module.exports = __webpack_public_path__ + "static/media/Apple.6ab3b64e.svg";